import { ProgressBar } from "react-bootstrap";

export type ImportProgressBarProps = { message: string; progress: number; isError: boolean };

export default function ImportProgressBar(props: ImportProgressBarProps) {
    const progress = Math.round(props.progress * 1000) / 1000;

    return (
        <label className="gap-1 d-flex flex-column w-100">
            {props.message}
            <ProgressBar
                style={{ height: "1.5rem" }}
                variant={props.isError ? "danger" : progress == 100 ? "success" : "primary"}
                now={props.progress}
                label={props.isError ? "Error" : `${Math.round(progress)}%`}
            />
        </label>
    );
}
